import type { LiffProfile } from '@/hooks/useLiff';
import type { InvitationValidateResponse } from '@/types/invitation';
import { Card } from '@/components/common/Card';
import { LineProfile } from './LineProfile';

interface LinkConfirmProps {
  lineProfile: LiffProfile;
  email: string | null;
  invitation: InvitationValidateResponse;
}

export const LinkConfirm = ({
  lineProfile,
  email,
  invitation,
}: LinkConfirmProps) => {
  return (
    <Card>
      <div className="space-y-6">
        {/* タイトル */}
        <div className="text-center">
          <h2 className="text-xl font-bold text-gray-900">LINE連携の確認</h2>
          <p className="text-sm text-gray-500 mt-1">
            以下の内容で連携を行います
          </p>
        </div>

        {/* 連携イメージ */}
        <div className="flex items-center justify-center gap-4">
          <div className="text-center">
            <div className="w-12 h-12 rounded-full bg-line flex items-center justify-center text-white mx-auto">
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.064-.021.136-.031.2-.031.211 0 .391.09.51.25l2.437 3.311V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
              </svg>
            </div>
            <p className="text-xs text-gray-500 mt-1">LINE</p>
          </div>

          <div className="flex items-center">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>

          <div className="text-center">
            <div className="w-12 h-12 rounded-full bg-flaro-primary flex items-center justify-center text-white mx-auto">
              <span className="text-lg font-bold">F</span>
            </div>
            <p className="text-xs text-gray-500 mt-1">FLARO</p>
          </div>
        </div>

        {/* LINEアカウント情報 */}
        <div>
          <p className="text-sm font-medium text-gray-700 mb-2">LINEアカウント</p>
          <LineProfile profile={lineProfile} email={email} />
        </div>

        {/* スタッフ情報 */}
        <div>
          <p className="text-sm font-medium text-gray-700 mb-2">連携先スタッフ</p>
          <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
            <div>
              <p className="font-bold text-gray-900">{invitation.staff_name}</p>
              <p className="text-sm text-gray-500">スタッフコード: {invitation.staff_code}</p>
            </div>
          </div>
        </div>

        {/* 注意事項 */}
        <div className="text-xs text-gray-500 bg-gray-50 p-3 rounded">
          <p>
            連携すると、LINEアカウントでFLAROにログインできるようになります。
            連携は後から解除することもできます。
          </p>
        </div>
      </div>
    </Card>
  );
};

export default LinkConfirm;
